<template>
  <div class="w-7/12">
    <SwdRemoteSearch v-if="getRoleAccess" class="w-[420px]" />
  </div>
  <!-- <div class="w-2/12 flex justify-center">
    <InlineSvg :src="IrisLogoStandart" width="100" height="40" />
  </div> -->
  <div class="w-5/12 flex justify-end items-center">
    <Help />
    <Customer v-if="memberPermissions.includes('create')" />
    <template v-if="showContent?.showNewLeadBtn">
      <NewProspectBtn v-if="showContent?.showProspectBtn" class="mx-2" />
    </template>
    <!-- <NewTRCMbtn /> -->
    <template v-if="showContent?.showNewLeadBtn">
      <NewOpportunityBtn v-if="showContent?.showOpportunityBtn" class="mr-2" />
    </template>
    <Contacts v-if="memberPermissions.includes('view-contacts')" />
    <Tasks v-if="tasksPermissions.includes('view')" />
    <Calendar v-if="!hideCalender && eventsPermissions.includes('view')" class="mr-2" />
    <HeaderNotificationsBlock v-if="showContent?.showNotificationBtn" class="mx-4" />
    <UserAction class="ml-2" />
  </div>
  <NewLeadModal />
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

import ROLE from '../../../enums/roles'

import IrisLogoStandart from '@/assets/svg/iris-logo-standard.svg'
import SwdRemoteSearch from '@/components/Global/SwdRemoteSearch.vue'
import Calendar from '@/components/Header/Calendar.vue'
import Contacts from '@/components/Header/Contacts.vue'
import Customer from '@/components/Header/Customer.vue'
import HeaderNotificationsBlock from '@/components/Header/HeaderNotificationsBlock.vue'
import Help from '@/components/Header/Help.vue'
import NewOpportunityBtn from '@/components/Header/NewOpportunityBtn.vue'
import NewProspectBtn from '@/components/Header/NewProspectBtn.vue'
import Tasks from '@/components/Header/Tasks.vue'
import NewLeadModal from '@/components/Modal/NewLeadModal.vue'
import UserAction from '@/components/UserAction.vue'
import { useShowContentEnv } from '@/hooks/use-show-content-env'

// import NewTRCMbtn from '@/components/Header/NewTRCMbtn.vue'

export default {
  name: 'AdvisorHeader',
  components: {
    UserAction,
    SwdRemoteSearch,
    HeaderNotificationsBlock,
    NewLeadModal,
    NewOpportunityBtn,
    // NewTRCMbtn,
    NewProspectBtn,
    Calendar,
    Tasks,
    Help,
    Customer,
    Contacts,
  },
  setup() {
    const store = useStore()
    const { showContent } = useShowContentEnv()
    const hideCalender = true
    const tasksPermissions = computed(
      () =>
        (store.state.globalComponents?.permissions?.permissionGroups?.tasks ?? [])
          .filter((perm) => perm.name.startsWith('tasks.'))
          .map((perm) => perm.name.split('.')[1]) || []
    )
    const eventsPermissions = computed(
      () =>
        (store.state.globalComponents?.permissions?.permissionGroups?.calendar ?? [])
          .filter((perm) => perm.name.startsWith('calendar.'))
          .map((perm) => perm.name.split('.')[1]) || []
    )
    const getRoleAccess = computed(() => {
      return store.state.globalComponents.currentTypeUser !== ROLE.LEAD ? true : false
    })
    // get member permissions from store and check if user has access to show content in header
    const memberPermissions = computed(
      () =>
        (store.state.globalComponents?.permissions?.permissionGroups?.member ?? [])
          .filter((perm) => perm.name.startsWith('member.'))
          .map((perm) => perm.name.split('.')[1]) || []
    )
    return {
      hideCalender,
      tasksPermissions,
      eventsPermissions,
      IrisLogoStandart,
      showContent,
      getRoleAccess,
      memberPermissions,
    }
  },
}
</script>
